import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { layoutTokens, semanticColors, textStyles } from "@/designTokens";

import considerationInfoIcon from "@assets/image/property_registration/consideration-info.svg";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "flex-start",
    gap: layoutTokens.space[8],
    padding: "12px 16px",
    borderRadius: layoutTokens.radius.md,
    backgroundColor: semanticColors["status/info-bg"],
  },
  iconSlot: { display: "flex", alignItems: "center", height: 18, flexShrink: 0 },
  text: { ...textStyles["SP/Body/Small"], color: semanticColors["text/primary"] },
});

export const ConsiderationRegistrationNotice: React.FC = () => {
  const classes = useStyles();
  return (
    <Box className={classes.root} role="note">
      <span className={classes.iconSlot}>
        <img src={considerationInfoIcon} alt="" aria-hidden="true" />
      </span>
      <Typography className={classes.text}>検討中物件は現在、区分のみ登録可能です</Typography>
    </Box>
  );
};
